import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Box, Typography } from "@mui/material";

import Modal from "../../components/Modal/Modal";
import { tl } from "../../components/translate";
import * as api from "../../api/serviceTags";
import { postServiceTag } from "../../actions/serviceTags";
import * as NotificationActions from "../../actions/notification";
import { IThunkDispatch } from "../../store";
import { IServiceTag } from "../../interfaces/ServiceTagsInterface";
import StatefulButton from "../../components/StatefulButton/StatefulButton";

interface Props {
  onClose: () => void;
  onSave?: (tag: IServiceTag) => void;
  initialNoun?: string;
  initialTag?: string;
}

const ServiceTagCreateEdit = ({
  onClose,
  onSave,
  initialNoun = "",
  initialTag = ""
}: Props): React.JSX.Element => {
  const dispatch = useDispatch<IThunkDispatch>();

  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    setLoading(true);
    try {
      const res = await api.postServiceTag({ noun: initialNoun, tag: initialTag });
      if (res?.id) {
        dispatch(postServiceTag(res));
        dispatch(
          NotificationActions.notificationAdd({
            id: new Date().getUTCMilliseconds(),
            variant: "success",
            message: "Service Tag Created!",
            autoTimeout: true
          })
        );
        if (onSave) {
          onSave(res);
        }
        onClose();
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      dispatch(
        NotificationActions.notificationAdd({
          id: new Date().getUTCMilliseconds(),
          variant: "error",
          message: error?.message || "Failed to create Service Tag",
          autoTimeout: true
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const footer = (
    <StatefulButton
      variant="contained"
      color="primary"
      disabled={loading}
      onClick={handleSave}
      isLoading={loading}
      circularProgressProps={{ size: 16 }}
      data-testmation="createServiceTag"
      style={{ height: "35px", width: "80px" }}
    >
      {tl("save")}
    </StatefulButton>
  );

  return (
    <Modal open title="Add Custom Service Tag" onClose={onClose} footer={footer}>
      <Box sx={{ p: 1 }}>
        <Typography>{`Are you sure you want to create "${initialNoun}" service tag?`}</Typography>
      </Box>
    </Modal>
  );
};

export default ServiceTagCreateEdit;
